import t from "react";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es18.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import e from "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import "./index.es33.js";
import "./index.es34.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es37.js";
import "./index.es38.js";
const j = ({
  body: o,
  title: r,
  tooltips: m,
  keyContext: i,
  isInfoBlock: p
}) => /* @__PURE__ */ t.createElement("div", { className: "bl-m-b-4 bl-rich-text" }, /* @__PURE__ */ t.createElement(
  e,
  {
    keyContext: `${i}-richtext`,
    content: o,
    tooltips: m,
    type: p === !1 ? "normal" : "infobox",
    title: r
  }
));
export {
  j as default
};
//# sourceMappingURL=index.es40.js.map
